'use strict';
var BaggagesModel = Odigeo.Model.extend({
    dataUrl: 'getselectedbaggages',
    defaults: {},
    url: function() {
        return Odigeo.Settings.getProperty('serviceUrlFormatter')(this.dataUrl);
    },
    getDataRequestSettings: function() {
        return {
            success: Odigeo._.bind(this.requestSuccessHandler, this),
            error: Odigeo._.bind(this.requestErrorHandler, this),
        };
    },
    requestSuccessHandler: function(data) {
        if (!Odigeo._.isEmpty(data)) {
            this.trigger('responseIsOK', data);
        }
    },
    requestErrorHandler: function() {
        this.trigger('responseIsKO');
    },
});
var instance;
module.exports.BaggagesModelClass = BaggagesModel;
module.exports.getInstance = function() {
    if (Odigeo._.isUndefined(instance)) {
        instance = new BaggagesModel();
    }

    return instance;
};
